import styled from 'styled-components'

import { Spacing } from '@/ui/atoms/spacing'

type AvailableDatesContainerProps = {
  hasDivider: boolean
}

export const AvailableDatesContainer = styled(Spacing)<AvailableDatesContainerProps>(
  ({ theme, hasDivider }) => `
  ${hasDivider ? ` border-top: .1rem solid ${theme.colors.grey.light4};` : null}
`
)
